export default __webpack_public_path__ + "static/media/salesforce.4ca50973.jpeg";